import React from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { pageItems } from './issuedFilters';
import { ALL_MANAGERS, managerOptions, pageText } from './issuedList';

// CreatedRange: the UTC days the comp was added on (created_at), both included.
export function CreatedRange({ from, to, onChange }) {
  return (
    <div className="flex items-center gap-1.5 text-xs font-medium text-ink-dim">
      <span>Added</span>
      <Input type="date" value={from} max={to || undefined} onChange={(e) => onChange({ from: e.target.value })}
        aria-label="Added from (UTC)" className="h-8 w-36 text-xs" />
      <span>to</span>
      <Input type="date" value={to} min={from || undefined} onChange={(e) => onChange({ to: e.target.value })}
        aria-label="Added to (UTC)" className="h-8 w-36 text-xs" />
      {(from || to) && (
        <Button variant="ghost" size="sm" className="px-2" onClick={() => onChange({ from: '', to: '' })} aria-label="Clear the dates">
          <X className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  );
}

// ManagerFilter: the VIP manager who saved the comp, or everyone.
export function ManagerFilter({ value, managers, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-56 text-xs" aria-label="Filter by VIP manager"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_MANAGERS}>All managers</SelectItem>
        {managerOptions(managers, value).map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

// Pager: "1–50 of 120", previous / numbered / next page buttons.
export function Pager({ data, page, lastPage, disabled, onPage }) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-1 text-xs font-medium text-ink-dim">
      <span className="mr-2">{pageText(data)}</span>
      <Button variant="ghost" size="sm" disabled={page <= 1 || disabled} onClick={() => onPage(page - 1)} aria-label="Previous page">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      {pageItems(page, lastPage).map((p, i) => (p === null
        ? <span key={`gap-${i}`} className="px-1 text-ink-mute">…</span>
        : (
          <Button
            key={p} size="sm" variant={p === page ? 'secondary' : 'ghost'} className="min-w-8 px-2 font-bold"
            aria-current={p === page ? 'page' : undefined} disabled={disabled} onClick={() => onPage(p)}
          >
            {p}
          </Button>
        )))}
      <Button variant="ghost" size="sm" disabled={page >= lastPage || disabled} onClick={() => onPage(page + 1)} aria-label="Next page">
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
